<template>
    <div>
        <div class="flex justify-between items-center">
            <toggle
                :name="toggleName"
                v-model="isEnabled"
            ></toggle>
            <span class="flex flex-col flex-grow">
                <span class="text-sm font-medium text-gray-900">Enable double opt-in</span>
                <span class="text-sm text-gray-500">If enabled, a confirmation email will be sent to the subscriber to confirm the subscription.</span>
            </span>
        </div>

        <div v-if="isEnabled" class="mt-4">
            <text-field
                label="Redirect URL"
                :name="urlInputName"
                :model-value="urlInputValue"
                placeholder="Enter redirect URL"
                class="w-full"
            >
                <template #note>
                    Enter the URL where subscribers will be redirected after confirming their subscription. If left blank, they will be redirected to the subscription form page.
                </template>
            </text-field>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    toggleName: {
        type: String,
        required: true
    },
    toggleEnabled: {
        type: Boolean,
        required: true
    },
    urlInputName: {
        type: String,
        required: true
    },
    urlInputValue: {
        type: String,
        default: ''
    }
});

const isEnabled = ref(!!props.toggleEnabled);
</script>

<style scoped>

</style>
